import React from 'react'
import { useTranslation } from "react-i18next";

function PeriButton({ text, onClick }) {
  const { t, i18n } = useTranslation("")

  return (
    <button
      onClick={onClick}
      className={`bg-[#C32D87] text-white py-2 px-6 rounded-full transition duration-300 ease-in-out min-w-[271px] 
        ${i18n.language === "vn" ? "font-bold text-[18px]" : "font-medium text-[20px]"} font-cera-pro-medium`}
    >
      {text}
    </button>
  )
}

export default PeriButton